import axios from "axios";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { BASE_URL, BASE_URL_PREBID, TEST_URL_PREBID } from "../../config/axios";
import { formattedDate, formattedDateLong } from "../Date";
import {
    formatCurrencyIndian,
    handleErrorToast,
    ViewFile,
    ViewOtherFile,
    ViewEmployeeList,
    formatRoundoff2D,
} from "../custom";
import {
    DropdownArrow,
    AddwithWhiteCircle,
    CheckGreen,
    Attachment,
    Eye,
    Reciept,
    UpdatePencilWhite,
    DeleteDustbin,
    CrossRed,
    MailIcon,
    CloudUpload,
} from "../AllSvg";
import { ToastContainer, toast } from "react-toastify";
import { StagesManagement } from "../Modals/Addstages";
import Updatestages from "../Modals/Updatestages";
import { useNavigate } from "react-router-dom";
import ReceivedAmount from "../../pages/account/Main/ReceivedAmount";
import { DeleteInvoice } from "./Invoice";
import Loader from "../Loader";

const AddProjectClientDetails = ({
    pid,
    allEmployeeData,
    getProjectDetails,
    clientslist,
    getProjectClientList,
}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            project: pid,
            client: "",
            client_name: "",
            pr_project: false,
            wo_date: "",
            target_date: "",
            due_date: "",
            woamount: "",
            gst_amount: "",
            without_gst_amount: "",
            confirm_by: "",
            confirmation_mode: "",
            status: "pending",
        });
        setAllClientsList([{}]);
        setErrors({});
        setShow(false);
    };
    const handleShow = () => {
        setFormData({
            project: pid,
            client: "",
            client_name: "",
            pr_project: false,
            wo_date: "",
            target_date: "",
            due_date: "",
            woamount: "",
            gst_amount: "",
            without_gst_amount: "",
            confirm_by: "",
            confirmation_mode: "",
            status: "pending",
        });
        getClientNames();
        setShow(true);
    };
    const [loading, setLoading] = useState(false); //loading logic
    const [formData, setFormData] = useState({
        project: pid,
        client: "",
        client_name: "",
        pr_project: false,
        wo_date: "",
        target_date: "",
        due_date: "",
        woamount: "",
        gst_amount: "",
        without_gst_amount: "",
        confirm_by: "",
        confirmation_mode: "",
        status: "pending",
    });

    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "project",
            "client",
            "client_name",
            // 'pr_project',
            "wo_date",
            "target_date",
            "due_date",
            "woamount",
            "gst_amount",
            "without_gst_amount",
            "confirm_by",
            "confirmation_mode",
            "status",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [allClientsList, setAllClientsList] = useState([]);
    const [allClientsNameList, setAllClientsNameList] = useState([]);
    const getClientNames = async () => {
        try {
            const clientNames = await axios.get(
                `${BASE_URL_PREBID}/project/clientName/`
            );
            setAllClientsNameList(clientNames.data);
        } catch (err) {
            console.error("Error fetching client data:", err.message);
            alert(err.message);
        }
    };

    const [buffer, setBuffering] = useState(true); //buffering logic
    const getClientDetails = async (id) => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const clients = await axios.get(
                `${BASE_URL_PREBID}/project/clientnamefilter/${id || "null"}/`
            );
            setAllClientsList(clients.data);
        } catch (err) {
            console.error("Error fetching client data:", err.message);
            alert(err.message);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.post(
                    `${BASE_URL_PREBID}/project/projectdetails/`,
                    formData
                );

                if (res.status === 200 || res.status === 201) {
                    await getProjectDetails();
                    await getProjectClientList();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {
            console.log("Form contains errors:", errors);
        }
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setInputState({
    //         ...inputState,
    //         [name]: value,
    //     });
    //     setFormData({
    //         ...formData,
    //         [name]: value,
    //     });
    //     setErrors((prevErrors) => {
    //         const updatedErrors = { ...prevErrors };
    //         if (value) {
    //             delete updatedErrors[name];
    //         }
    //         return updatedErrors;
    //     });
    // };

    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;

        if (name === "without_gst_amount") {
            const withoutGstAmount = parseFloat(value) || 0;
            const gstPercentage = 0.18;
            const gstAmount = (withoutGstAmount * gstPercentage).toFixed(2);
            const woAmount = (withoutGstAmount + parseFloat(gstAmount)).toFixed(2);

            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
                gst_amount: gstAmount,
                woamount: woAmount,
            }));

            setInputState({
                ...inputState,
                [name]: value,
            });
        }

        if (name === "client_name") {
            getClientDetails(value);
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));

            setInputState({
                ...inputState,
                [name]: value,
            });
        }

        if (name === "client") {
            const clientExists = clientslist.normal_client?.length > 0;

            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
                pr_project: clientExists,
            }));

            setInputState((prevState) => ({
                ...prevState,
                pr_project: clientExists ? "green" : "",
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));

            setInputState({
                ...inputState,
                [name]: value,
            });
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    const gstPercentage = 0.18; // 18% GST rate in decimal form
    const withoutGstAmount = parseFloat(formData.without_gst_amount);
    const gstAmount = (withoutGstAmount * gstPercentage).toFixed(2);
    const woAmount = (withoutGstAmount + parseFloat(gstAmount)).toFixed(2);

    const updatedFormData = {
        ...formData,
        gst_amount: gstAmount,
        woamount: woAmount,
    };

    // console.log("add formData")
    // console.log(formData)

    return (
        <>
            <button className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle /> Add Client
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="dialog-modal-assign-task dialog-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Add Client Details </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                    <div className="modal-body-padding">
                        <form>
                            <div className="form-flex-wrap">
                                <div className="flex-column form-group-select">
                                    <label className="form-labels">
                                        Client Name:<span className="required">*</span>
                                    </label>
                                    <select
                                        name="client_name"
                                        value={formData.client_name}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.client_name
                                            ? "error"
                                            : inputState.client_name
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Client</option>
                                        {allClientsNameList.map((clientnames) => (
                                            <option key={clientnames.id} value={clientnames.id}>
                                                {clientnames.title}
                                            </option>
                                        ))}
                                    </select>
                                    {/* <DropdownArrow /> */}
                                    {errors.client_name && (
                                        <span className="error-message">{errors.client_name}</span>
                                    )}
                                </div>

                                <div className="flex-column form-group-select">
                                    <label className="form-labels">
                                        Client Pos:
                                        <span className="required">
                                            {formData.client_name ? "*" : "(Select Client Name)"}
                                        </span>
                                    </label>
                                    {buffer ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                name="client"
                                                value={formData.client}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.client
                                                    ? "error"
                                                    : inputState.client
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a Client</option>
                                                {allClientsList.map((client) => (
                                                    <option key={client.id} value={client.id}>
                                                        {client.pos}, GSTIN : {client.gstin_number}
                                                    </option>
                                                ))}
                                            </select>
                                            {/* <DropdownArrow /> */}
                                            {errors.client && (
                                                <span className="error-message">{errors.client}</span>
                                            )}
                                        </>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Work Order Date:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        name="wo_date"
                                        value={formData.wo_date || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.wo_date
                                            ? "error"
                                            : inputState.wo_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.wo_date && (
                                        <span className="error-message">{errors.wo_date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Target Date:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        name="target_date"
                                        value={formData.target_date || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.target_date
                                            ? "error"
                                            : inputState.target_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.target_date && (
                                        <span className="error-message">{errors.target_date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Due Date:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        name="due_date"
                                        value={formData.due_date || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.due_date
                                            ? "error"
                                            : inputState.due_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.due_date && (
                                        <span className="error-message">{errors.due_date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Work Order Amount:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="without_gst_amount"
                                        value={formData.without_gst_amount || ""}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.without_gst_amount
                                            ? "error"
                                            : inputState.without_gst_amount
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.without_gst_amount && (
                                        <span className="error-message">
                                            {errors.without_gst_amount}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        GST Amount:<span className="required">(View Only)</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="gst_amount"
                                        readonly
                                        disabled
                                        style={{ cursor: "not-allowed" }}
                                        value={formData.gst_amount || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.gst_amount
                                            ? "error"
                                            : inputState.gst_amount
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.gst_amount && (
                                        <span className="error-message">{errors.gst_amount}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Total Amount:<span className="required">(View Only)</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="woamount"
                                        readonly
                                        disabled
                                        style={{ cursor: "not-allowed" }}
                                        value={formData.woamount || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.woamount
                                            ? "error"
                                            : inputState.woamount
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.woamount && (
                                        <span className="error-message">{errors.woamount}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Confirm By:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="confirm_by"
                                        value={formData.confirm_by || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.confirm_by
                                            ? "error"
                                            : inputState.confirm_by
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.confirm_by && (
                                        <span className="error-message">{errors.confirm_by}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Confirmation Mode:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="confirmation_mode"
                                        value={formData.confirmation_mode || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.confirmation_mode
                                            ? "error"
                                            : inputState.confirmation_mode
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.confirmation_mode && (
                                        <span className="error-message">
                                            {errors.confirmation_mode}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column form-group-select">
                                    <label className="form-labels">
                                        Status:<span className="required">*</span>
                                    </label>
                                    <select
                                        name="status"
                                        value={formData.status || ""}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.status
                                            ? "error"
                                            : inputState.status
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="inprogress">In Progress</option>
                                        <option value="cancelled">Cancelled</option>
                                        <option value="completed">Completed</option>
                                        <option value="hold">Hold</option>
                                    </select>
                                    {/* <DropdownArrow /> */}
                                    {errors.status && (
                                        <span className="error-message">{errors.status}</span>
                                    )}
                                </div>
                            </div>
                            {/* <div className="flex-row">
                                <label htmlFor="pr_project" className="form-labels">
                                    PR Project {" "}
                                </label>
                                <hr className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="pr_toggle"
                                        name="pr_project"
                                        type="checkbox"
                                        className={`form-checkbox`}
                                        onChange={(e) =>
                                            handleInputChange({
                                                target: {
                                                    name: "pr_project",
                                                    value: e.target.checked,
                                                },
                                            })
                                        }
                                        checked={formData.pr_project}
                                    />
                                    <label htmlFor="pr_toggle"></label>
                                </div>
                            </div> */}
                            {errors.project && (
                                <span className="error-message">{errors.project}</span>
                            )}

                            <div className="button-models">
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    className="model-button model-button-submit"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteProjectClientDetails = ({ i }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/project/projectdetailsupdate/${i.id}/`
            );

            if (res.status === 200) {
                window.location.reload();
                // await getProjectClientDetailsData();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Project Client Details"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Project Client Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete the Project Client Details:
                        {/* <strong>"{i.client_full_name}"</strong>? */}
                    </p>

                    <div>
                        <ul>
                            <li>
                                <strong>Project Name:</strong> {i.project_name}
                            </li>
                            <li>
                                <strong>Client Full Name:</strong> {i.client_full_name}
                            </li>
                            <li>
                                <strong>Work Order Date:</strong> {i.wo_date}
                            </li>
                            <li>
                                <strong>Target Date:</strong> {i.target_date}
                            </li>
                            <li>
                                <strong>Due Date:</strong> {i.due_date}
                            </li>
                            <li>
                                <strong>Amount (Without GST):</strong> ₹{i.without_gst_amount}
                            </li>
                            <li>
                                <strong>GST Amount:</strong> ₹{i.gst_amount}
                            </li>
                            <li>
                                <strong>Total Amount (With GST):</strong> ₹{i.woamount}
                            </li>
                            <li>
                                <strong>Status:</strong> {i.status}
                            </li>
                        </ul>
                    </div>

                    <p>
                        This action will also delete all details related to this project
                        client, including client details, and related work stages details.
                    </p>

                    <div className="button-models">
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateProjectClientDetails = ({
    clientDetailsData,
    pid,
    allEmployeeData,
    getClientDetails,
    clientslist,
    getProjectClientList,
}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            project: pid,
            client: "",
            client_name: "",
            pr_project: false,
            wo_date: "",
            target_date: "",
            due_date: "",
            woamount: "",
            gst_amount: "",
            without_gst_amount: "",
            confirm_by: "",
            confirmation_mode: "",
            status: "pending",
        });
        setErrors({});
        setShow(false);
    };
    const handleShow = () => {
        setFormData(clientDetailsData);
        getClientListDetails();
        setShow(true);
    };
    const [loading, setLoading] = useState(false); //loading logic
    const [formData, setFormData] = useState({
        project: pid,
        client: "",
        client_name: "",
        pr_project: false,
        wo_date: "",
        target_date: "",
        due_date: "",
        woamount: "",
        gst_amount: "",
        without_gst_amount: "",
        confirm_by: "",
        confirmation_mode: "",
        status: "pending",
    });

    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "project",
            "client",
            "client_name",
            // 'pr_project',
            "wo_date",
            "target_date",
            "due_date",
            "woamount",
            "gst_amount",
            "without_gst_amount",
            "confirm_by",
            "confirmation_mode",
            "status",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [allClientsList, setAllClientsList] = useState([]);
    const [allClientsNameList, setAllClientsNameList] = useState([]);
    const getClientListDetails = async () => {
        try {
            const clients = await axios.get(`${BASE_URL_PREBID}/project/allclient/`);
            setAllClientsList(clients.data);
            const clientNames = await axios.get(
                `${BASE_URL_PREBID}/project/clientName/`
            );
            setAllClientsNameList(clientNames.data);
        } catch (err) {
            console.error("Error fetching client data:", err.message);
            alert(err.message);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(
                    `${BASE_URL_PREBID}/project/projectdetailsupdate/${clientDetailsData.id}/`,
                    formData
                );

                if (res.status === 200 || res.status === 201) {
                    await getClientDetails();
                    await getProjectClientList();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {
            console.log("Form contains errors:", errors);
        }
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setInputState({
    //         ...inputState,
    //         [name]: value,
    //     });
    //     setFormData({
    //         ...formData,
    //         [name]: value,
    //     });
    //     setErrors((prevErrors) => {
    //         const updatedErrors = { ...prevErrors };
    //         if (value) {
    //             delete updatedErrors[name];
    //         }
    //         return updatedErrors;
    //     });
    // };

    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;

        if (name === "without_gst_amount") {
            const withoutGstAmount = parseFloat(value) || 0;
            const gstPercentage = 0.18;
            const gstAmount = (withoutGstAmount * gstPercentage).toFixed(2);
            const woAmount = (withoutGstAmount + parseFloat(gstAmount)).toFixed(2);

            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
                gst_amount: gstAmount,
                woamount: woAmount,
            }));

            setInputState({
                ...inputState,
                [name]: value,
            });
        }

        if (name === "client") {
            const clientExists = clientslist.normal_client?.length > 0;

            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
                pr_project: clientExists,
            }));

            setInputState((prevState) => ({
                ...prevState,
                pr_project: clientExists ? "green" : "",
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));

            setInputState({
                ...inputState,
                [name]: value,
            });
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target || e;

        // Handle checkbox, CreatableSelect, or standard input change
        const inputValue = type === "checkbox" ? checked : value;

        setInputState({
            ...inputState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : value.trim()
                        ? "green"
                        : "",
        });

        setFormData({
            ...formData,
            [name]: inputValue,
        });
    };

    console.log("UpdateformData");
    console.log(formData);

    return (
        <>
            <button className="upload-svg" onClick={handleShow}>
                <UpdatePencilWhite /> Update Client
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="dialog-modal-assign-task dialog-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">
                        Update Client Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                    <div className="modal-body-padding">
                        <form>
                            <div className="form-flex-wrap">
                                <div className="flex-column form-group-select">
                                    <label className="form-labels">
                                        Client Name:<span className="required">(View Only)</span>
                                    </label>
                                    <select
                                        name="client_name"
                                        value={formData.client_name}
                                        onChange={handleInputChange}
                                        readonly
                                        disabled
                                        style={{ cursor: "not-allowed" }}
                                        className={`form-input form-group-selection ${errors.client_name
                                            ? "error"
                                            : inputState.client_name
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Client</option>
                                        {allClientsNameList.map((clientnames) => (
                                            <option key={clientnames.id} value={clientnames.id}>
                                                {clientnames.title}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.client_name && (
                                        <span className="error-message">{errors.client_name}</span>
                                    )}
                                </div>

                                <div className="flex-column form-group-select">
                                    <label className="form-labels">
                                        Client:<span className="required">(View Only)</span>
                                    </label>
                                    <select
                                        name="client"
                                        value={formData.client}
                                        onChange={handleInputChange}
                                        readonly
                                        disabled
                                        style={{ cursor: "not-allowed" }}
                                        className={`form-input form-group-selection ${errors.client
                                            ? "error"
                                            : inputState.client
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Client</option>
                                        {allClientsList.map((client) => (
                                            <option key={client.id} value={client.id}>
                                                {client.pos}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.client && (
                                        <span className="error-message">{errors.client}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Work Order Date:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        name="wo_date"
                                        value={formData.wo_date || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.wo_date
                                            ? "error"
                                            : inputState.wo_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.wo_date && (
                                        <span className="error-message">{errors.wo_date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Target Date:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        name="target_date"
                                        value={formData.target_date || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.target_date
                                            ? "error"
                                            : inputState.target_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.target_date && (
                                        <span className="error-message">{errors.target_date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Due Date:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        name="due_date"
                                        value={formData.due_date || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.due_date
                                            ? "error"
                                            : inputState.due_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.due_date && (
                                        <span className="error-message">{errors.due_date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Work Order Amount:
                                        {sessionStorage.getItem("role") !== "HOD" && <span className="required">(View Only)</span>}
                                    </label>
                                    <input
                                        type="number"
                                        name="without_gst_amount"
                                        value={formData.without_gst_amount || ""}
                                        readOnly={sessionStorage.getItem("role") !== "HOD"}
                                        disabled={sessionStorage.getItem("role") !== "HOD"}
                                        style={{ cursor: sessionStorage.getItem("role") === "HOD" ? "auto" : "not-allowed" }}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.without_gst_amount
                                            ? "error"
                                            : inputState.without_gst_amount
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.without_gst_amount && (
                                        <span className="error-message">
                                            {errors.without_gst_amount}
                                        </span>
                                    )}

                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        GST Amount:<span className="required">(View Only)</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="gst_amount"
                                        readonly
                                        disabled
                                        style={{ cursor: "not-allowed" }}
                                        value={formData.gst_amount || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.gst_amount
                                            ? "error"
                                            : inputState.gst_amount
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.gst_amount && (
                                        <span className="error-message">{errors.gst_amount}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Total Amount:<span className="required">(View Only)</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="woamount"
                                        readonly
                                        disabled
                                        style={{ cursor: "not-allowed" }}
                                        value={formData.woamount || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.woamount
                                            ? "error"
                                            : inputState.woamount
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.woamount && (
                                        <span className="error-message">{errors.woamount}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Confirm By:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="confirm_by"
                                        value={formData.confirm_by || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.confirm_by
                                            ? "error"
                                            : inputState.confirm_by
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.confirm_by && (
                                        <span className="error-message">{errors.confirm_by}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Confirmation Mode:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="confirmation_mode"
                                        value={formData.confirmation_mode || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.confirmation_mode
                                            ? "error"
                                            : inputState.confirmation_mode
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.confirmation_mode && (
                                        <span className="error-message">
                                            {errors.confirmation_mode}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column form-group-select">
                                    <label className="form-labels">
                                        Status:<span className="required">*</span>
                                    </label>
                                    <select
                                        name="status"
                                        value={formData.status || ""}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.status
                                            ? "error"
                                            : inputState.status
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="inprogress">In Progress</option>
                                        <option value="cancelled">Cancelled</option>
                                        <option value="completed">Completed</option>
                                        <option value="hold">Hold</option>
                                    </select>
                                    {/* <DropdownArrow /> */}
                                    {errors.status && (
                                        <span className="error-message">{errors.status}</span>
                                    )}
                                </div>
                            </div>
                            {/* <div className="flex-row">
                                <label htmlFor="pr_project" className="form-labels">
                                    PR Project {" "}
                                </label>
                                <hr className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="pr_toggle"
                                        name="pr_project"
                                        type="checkbox"
                                        className={`form-checkbox`}
                                        onChange={(e) =>
                                            handleInputChange({
                                                target: {
                                                    name: "pr_project",
                                                    value: e.target.checked,
                                                },
                                            })
                                        }
                                        checked={formData.pr_project}
                                    />
                                    <label htmlFor="pr_toggle"></label>
                                </div>
                            </div> */}
                            {errors.project && (
                                <span className="error-message">{errors.project}</span>
                            )}

                            <div className="button-models">
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    className="model-button model-button-submit"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ProjectClientDetailsTable = ({
    projectID,
    client,
    clientwiseID,
    clientslist,
    getProjectClientList,
    projectEmployeeList,
    associated,
    clientIndex,
    projectshortname,
}) => {
    const [buffer, setBuffering] = useState(false);
    const [clientDetailsData, setClientDetailsData] = useState([]);

    useEffect(() => {
        if (client) {
            getClientDetails();
        }
    }, [client]);

    const getClientDetails = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(
                `${BASE_URL}/project/project-details/${projectID}/${client}/`
            );
            setClientDetailsData(response.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    const department = sessionStorage.getItem("department");

    return (
        <>
            <div className="table-css-white-background">
                <div className="heading-bg-color-white">
                    <div className="jd-heading-outer-flex ">
                        <h2 className="jd-heading-main font-weight600  font-size-heading">
                            Client Details of "{clientDetailsData?.client_name_title}"{" "}
                            <span className="required">
                                {clientDetailsData?.pr_project
                                    ? `(PR-${clientIndex + 1} Project)`
                                    : ""}
                            </span>{" "}
                        </h2>
                        <div className="field-cont">
                            {department === "Accounts" ? (
                                <StagesManagement
                                    getproject={getProjectClientList}
                                    id={clientwiseID}
                                />
                            ) : clientDetailsData?.status ===
                                "pending" ? null : associated === true ? (
                                    <Updatestages
                                        projectID={projectID}
                                        id={clientwiseID}
                                        allEmployeeData={projectEmployeeList}
                                    />
                                ) : sessionStorage.getItem("edit_project_access") === "true" ? (
                                    <Updatestages
                                        projectID={projectID}
                                        id={clientwiseID}
                                        allEmployeeData={projectEmployeeList}
                                    />
                                ) : null}

                            {associated === true ? (
                                <UpdateProjectClientDetails
                                    clientDetailsData={clientDetailsData}
                                    pid={projectID}
                                    getClientDetails={getClientDetails}
                                    clientslist={clientslist}
                                    getProjectClientList={getProjectClientList}
                                />
                            ) : (
                                sessionStorage.getItem("edit_project_access") === "true" && (
                                    <>
                                        <UpdateProjectClientDetails
                                            clientDetailsData={clientDetailsData}
                                            pid={projectID}
                                            getClientDetails={getClientDetails}
                                            clientslist={clientslist}
                                            getProjectClientList={getProjectClientList}
                                        />
                                        <DeleteProjectClientDetails i={clientDetailsData} />
                                    </>
                                )
                            )}
                        </div>
                    </div>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                <div className="info-box-div">
                    <div className="flex-row justify-between">
                        <div className="personal-detail">
                            {buffer ? (
                                <Loader />
                            ) : (
                                <table className="width-40vw">
                                    {console.log(clientDetailsData, 'cllientdata')}
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Project Name
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {projectshortname}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Client GST Name
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.client_full_name
                                                ? clientDetailsData?.client_full_name
                                                : "-"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Work Order Date
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.wo_date
                                                ? formattedDateLong(clientDetailsData?.wo_date)
                                                : "-"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Target Date
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.target_date
                                                ? formattedDateLong(clientDetailsData?.target_date)
                                                : "-"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Due Date
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.due_date
                                                ? formattedDateLong(clientDetailsData?.due_date)
                                                : "-"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Status
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text form-text-trasformation-uppercase">
                                            {clientDetailsData?.status
                                                ? clientDetailsData?.status
                                                : "-"}
                                        </th>
                                    </tr>
                                </table>
                            )}
                        </div>

                        <div className="personal-detail">
                            {buffer ? (
                                <div className="spinner-small"></div>
                            ) : (
                                <table className="width-40vw">
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Work Order Amount
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.without_gst_amount
                                                ? formatCurrencyIndian(
                                                    clientDetailsData.without_gst_amount
                                                )
                                                : "-"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            GST Amount
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.gst_amount
                                                ? formatCurrencyIndian(clientDetailsData.gst_amount)
                                                : "-"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Total Amount (with GST)
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.woamount
                                                ? formatCurrencyIndian(clientDetailsData.woamount)
                                                : "-"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Confirm By
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.confirm_by
                                                ? clientDetailsData?.confirm_by
                                                : "-"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td className="personal-detail-1 font-weight500 font-size-text">
                                            Confirmation Mode
                                        </td>
                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                            {clientDetailsData?.confirmation_mode
                                                ? clientDetailsData?.confirmation_mode
                                                : "-"}
                                        </th>
                                    </tr>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const DeleteWorkStage = ({ i, getWorkStagesData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/project/workstageupdate/${i.wid}/`
            );

            if (res.status === 200) {
                await getWorkStagesData();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Work Stage"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Work Stage</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are You Sure, You want to Delete Work Stage "{i.workStages}"
                    <div className="button-models">
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ProjectWorkStagesTable = ({
    projectID,
    client,
    clientwiseID,
    associated,
}) => {
    const [buffer, setBuffering] = useState(false);
    const [workStagesData, setWorkStagesData] = useState([]);

    useEffect(() => {
        if (client) {
            getWorkStagesData();
        }
    }, [client]);

    const getWorkStagesData = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL_PREBID}/project/workstagesbyprojectDetail/${clientwiseID}/`
            );
            setWorkStagesData(res.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    return (
        <>
            <div className="table-css-white-background">
                {/* <div className="attendance-box"> */}
                <div className="heading-bg-color-white">
                    <div className="jd-heading-outer-flex ">
                        <h2 className="jd-heading-main font-weight600  font-size-heading">
                            Work Stages
                        </h2>
                        <div className="field-cont"></div>
                    </div>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                {/* <div className="datagrid-container">
                    <div className="invoice-table"> */}

                <div
                    className="invoice-table2 "
                    // className={!buffer ? "invoice-table2 height-0vh" : "invoice-table2 "}
                    style={{
                        width: "100%",
                        // height: buffer ? "ovh" : "35vh"
                    }}
                >
                    <table
                        className="custom-table"
                    // className={!buffer ? "custom-table height-0vh" : "custom-table"}
                    >
                        <thead>
                            <tr className="custom-table-head-trr">
                                <th className="align-center">S. No.</th>
                                <th className="align-center">Work Stage</th>
                                <th className="align-center">Percentage</th>
                                <th className="align-center width-5vw">View Employees</th>
                                <th className="align-center">Add Docs</th>
                                <th className="align-center">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <Loader />
                        ) : (
                            <tbody>
                                {workStagesData
                                    ?.sort(
                                        (a, b) =>
                                            new Date(a.created_at).getTime() -
                                            new Date(b.created_at).getTime()
                                    ) // Sort by `created_at`
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="6"></td>
                                            </tr>
                                            <tr className="custom-table-head-tddd font-weight500 font-size-label">
                                                <td className="align-center">{index + 1}</td>
                                                <td className="align-center">{i.workStages}</td>
                                                <td className="align-center">{i.percentage}</td>

                                                <td className="align-center">
                                                    <div
                                                        className="flex-row align-center"
                                                        style={{ justifyContent: "center" }}
                                                    >
                                                        {i.employee_count}
                                                        <hr className="field-cont-hr" />
                                                        <ViewEmployeeList
                                                            titlename={`Employees Assigned to "${i.workStages}" `}
                                                            list={i.employee_detail}
                                                        />
                                                    </div>
                                                </td>

                                                <td className="align-center width-10vw ">
                                                    {/* <div className="flex-row width-5vw"> */}
                                                    {associated === true ? (
                                                        <AddSubmissionDocuments
                                                            projectID={projectID}
                                                            clientwiseID={clientwiseID}
                                                            getWorkStagesData={getWorkStagesData}
                                                            workstageId={i.wid}
                                                        />
                                                    ) : (
                                                        sessionStorage.getItem("edit_project_access") ===
                                                        "true" && (
                                                            <AddSubmissionDocuments
                                                                projectID={projectID}
                                                                clientwiseID={clientwiseID}
                                                                getWorkStagesData={getWorkStagesData}
                                                                workstageId={i.wid}
                                                            />
                                                        )
                                                    )}
                                                    {/* </div> */}
                                                </td>
                                                {!i.invoice_generated && !i.completed ? (
                                                    <td className="align-center width-5vw ">
                                                        {associated === true ? (
                                                            <DeleteWorkStage
                                                                i={i}
                                                                getWorkStagesData={getWorkStagesData}
                                                            />
                                                        ) : (
                                                            sessionStorage.getItem(
                                                                "delete_project_access"
                                                            ) === "true" && (
                                                                <DeleteWorkStage
                                                                    i={i}
                                                                    getWorkStagesData={getWorkStagesData}
                                                                />
                                                            )
                                                        )}
                                                    </td>
                                                ) : null}
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>

                {/* </div>
                </div> */}
                {/* </div> */}
            </div>
        </>
    );
};

const DeleteProjectDocuments = ({ id, getDocuments }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            console.log("Delete Expense Detail Api");
            let res = await axios.delete(
                `${BASE_URL}/project/documentupdate/${id.id}/`
            );

            if (res.status === 200) {
                await getDocuments();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are You Sure, You want to Delete this File
                    <div className="button-models">
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const PerformaInvoice = ({ id }) => {
    //   ****************   Modal Section
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        getClientDetails();
    };

    const [formData, setFormData] = useState({
        billing_date: "",
        invoice_number: "",
        billamount: "",
        gst_amount: "",
        wihoutgst_amount: "",
        bill_percentage: "",
        work_stages: "",
        project: "",
    });

    const [allWorkStagesStats, setAllWorkstagesStatus] = useState([]);

    const [filteredWorkStagesNames, setFilteredWorkStagesNames] = useState([]);
    const [totalPercentage, setTotalPercentage] = useState([]);

    const getClientDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL_PREBID}/project/pendingforInvoiceforaccount/${id}/`
            );

            const ress = await axios.get(
                `${BASE_URL_PREBID}/project/projectdetails/${id}/`
            );

            const workStages = res.data;

            setAllWorkstagesStatus(res.data);

            const workStageNames = workStages
                .map((entry) => entry.workStages)
                .join(", ");
            setFilteredWorkStagesNames(workStageNames);

            // Calculate the sum of total percentage
            const totalPercentage = workStages.reduce(
                (acc, entry) => acc + entry.percentage,
                0
            );

            setTotalPercentage(totalPercentage);

            const woamount = ress.data.without_gst_amount; // Assuming total amount is stored in res.data[0].woamount

            const billPercentageDecimal = totalPercentage / 100;

            const billAmount = woamount * billPercentageDecimal;

            const gstPercentage = 0.18; // 18% GST rate in decimal form

            const gstAmount = billAmount * gstPercentage;

            setFormData({
                billamount: billAmount + gstAmount,
                gst_amount: gstAmount,
                wihoutgst_amount: billAmount,
                bill_percentage: totalPercentage,
                work_stages: workStageNames,
                project: id,
            });
        } catch (err) {
            alert(err.message);
        }
    };

    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = ["invoice_number"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    console.log(formData);
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        const updatedFormData = {
            ...formData,
            billing_date: formattedDate,
        };

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            setLoading(true); //loading logic
            try {
                let res = await axios.post(
                    `${BASE_URL_PREBID}/project/generateinvoice/${id}/`,
                    updatedFormData
                );

                if (res.status === 200) {
                    window.location.reload();
                } else {
                    alert(res);
                }
            } catch (err) {
                // alert(err);
                if (err.response) {
                    toast.dismiss(loadingToastId);
                    const errorData = err.response.data;

                    if (typeof errorData.error === "string") {
                        // Single error message
                        toast.error(`Error: ${errorData.error}`);
                    } else if (typeof errorData === "object" && errorData !== null) {
                        // Multiple error messages
                        Object.entries(errorData).forEach(([field, messages]) => {
                            messages.forEach((message) =>
                                toast.error(`"${field}": ${message}`)
                            );
                        });
                    } else {
                        toast.error("Error:- Failed to Process!");
                    }
                } else {
                    toast.error("Error processing your request.");
                }
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    return (
        <>
            <button
                title="Generate Invoice"
                onClick={handleShow}
                className="upload-svga "
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    enable-background="new 0 0 32 32"
                    viewBox="0 0 32 32"
                    fill="white"
                    id="add"
                >
                    <path d="M2.4375,17.9375h11.625v11.625c0,1.06854,0.86896,1.9375,1.9375,1.9375s1.9375-0.86896,1.9375-1.9375v-11.625h11.625c1.06854,0,1.9375-0.86896,1.9375-1.9375s-0.86896-1.9375-1.9375-1.9375h-11.625V2.4375C17.9375,1.36896,17.06854,0.5,16,0.5s-1.9375,0.86896-1.9375,1.9375v11.625H2.4375C1.36896,14.0625,0.5,14.93146,0.5,16S1.36896,17.9375,2.4375,17.9375z"></path>
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="dialog-modal-assign-task"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">PerformaInvoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                    <div className="modal-body-padding">
                        <form>
                            <div className="form-flex-wrap">
                                <div className="flex-column">
                                    <label>
                                        Invoice Number:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="invoice_number"
                                        value={formData.invoice_number}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.invoice_number
                                            ? "error"
                                            : inputState.invoice_number
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.invoice_number && (
                                        <span className="error-message">
                                            {errors.without_gst_invoice_numbermount}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="button-models">
                                <button
                                    onClick={handleSubmit}
                                    className="model-button model-button-submit"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const Invoice = ({ id, getInvoiceDetails }) => {
    //   ****************   Modal Section
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        getClientDetails();
    };

    const [formData, setFormData] = useState({
        billing_date: "",
        pi_invoice_number: "",
        billamount: "",
        gst_amount: "",
        wihoutgst_amount: "",
        bill_percentage: "",
        work_stages: "",
        project_detail: "",
    });

    const getClientDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL_PREBID}/project/pendingforInvoiceforaccount/${id}/`
            );

            const ress = await axios.get(
                `${BASE_URL_PREBID}/project/projectdetailsupdate/${id}/`
            );

            const workStages = res.data;

            const workStageNames = workStages
                .map((entry) => entry.workStages)
                .join(", ");

            // Calculate the sum of total percentage
            const totalPercentage = workStages.reduce(
                (acc, entry) => acc + entry.percentage,
                0
            );

            const woamount = ress.data.without_gst_amount; // Assuming woamount is without GST
            const billPercentageDecimal = totalPercentage / 100;

            // Calculate bill amount (without GST)
            const billAmount = woamount * billPercentageDecimal;

            // 18% GST calculation
            const gstPercentage = 0.18;
            const gstAmount = (billAmount * gstPercentage).toFixed(2);

            // Determine GST type based on state codes
            if (
                ress.data?.client_gst_number?.substring(0, 2) ===
                ress.data?.company_gst_number?.substring(0, 2)
            ) {

                setFormData((prev) => ({
                    ...prev,
                    igst_amount: gstAmount,
                    cgst_amount: 0,
                    sgst_amount: 0,
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    cgst_amount: (gstAmount / 2).toFixed(2),
                    sgst_amount: (gstAmount / 2).toFixed(2),
                    igst_amount: 0,
                }));
            }

            // Set remaining form data
            setFormData((prev) => ({
                ...prev,
                billamount: (Number(billAmount) + Number(gstAmount)).toFixed(2),
                gst_amount: gstAmount,
                wihoutgst_amount: billAmount.toFixed(2),
                bill_percentage: totalPercentage,
                work_stages: workStageNames,
                project_detail: id,
            }));
        } catch (err) {
            alert(err.message);
        }
    };

    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = ["pi_invoice_number"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    console.log(formData);
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        const updatedFormData = {
            ...formData,
            billing_date: formattedDate,
        };

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            setLoading(true); //loading logic
            try {
                let res = await axios.post(
                    `${BASE_URL_PREBID}/project/generateinvoice/${id}/`,
                    updatedFormData
                );

                if (res.status === 200) {
                    await getInvoiceDetails();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    return (
        <>
            {/*     
        <button className="models-button model-add" onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clip-path="url(#clip0_1415_3177)">
              <path
                d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                fill="#2576BC"
              />
            </g>
            <defs>
              <clipPath id="clip0_1415_3177">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button> */}
            <button
                title="Generate Invoice"
                onClick={handleShow}
                className="upload-svg "
            >
                Generate Performa Invoice{" "}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    enable-background="new 0 0 32 32"
                    viewBox="0 0 32 32"
                    fill="white"
                    id="add"
                >
                    <path d="M2.4375,17.9375h11.625v11.625c0,1.06854,0.86896,1.9375,1.9375,1.9375s1.9375-0.86896,1.9375-1.9375v-11.625h11.625c1.06854,0,1.9375-0.86896,1.9375-1.9375s-0.86896-1.9375-1.9375-1.9375h-11.625V2.4375C17.9375,1.36896,17.06854,0.5,16,0.5s-1.9375,0.86896-1.9375,1.9375v11.625H2.4375C1.36896,14.0625,0.5,14.93146,0.5,16S1.36896,17.9375,2.4375,17.9375z"></path>
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="dialog-modal-assign-task"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">
                        Generate Performa Invoice
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                    <div className="modal-body-padding">
                        <form>
                            <div className="form-flex-wrap">
                                <div className="flex-column">
                                    <label htmlFor="pi_invoice_number">
                                        Performa Invoice Number:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="pi_invoice_number"
                                        id="pi_invoice_number"
                                        value={formData.pi_invoice_number}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.pi_invoice_number
                                            ? "error"
                                            : inputState.pi_invoice_number
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.pi_invoice_number && (
                                        <span className="error-message">
                                            {errors.pi_invoice_number}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="button-models">
                                <button
                                    onClick={handleSubmit}
                                    className="model-button model-button-submit"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ConfirmInvoice = ({ i, getInvoiceDetails, workStagesData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const [formData, setFormData] = useState({
        invoice_number: "",
        invoice_date: formattedDate,
        document: '',
    });

    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        let requiredFields = []
        if (workStagesData.length > 1) {
            requiredFields = ["invoice_number", "document"]
        } else {
            requiredFields = ["invoice_number"]
        }
        // const requiredFields = ["invoice_number", "document"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const updatedFormData = {
            ...formData,
            invoice_date: formattedDate,
            invoice_confirmation
                : true,
        };

        // Create FormData object
        const formDataToSend = new FormData();

        // Append all fields to FormData
        for (const key in updatedFormData) {

            if (key === "document" && workStagesData.length > 1) {
                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-"); // Format: YYYY-MM-DD
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-"); // Format: HH-MM-SS
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }
                const originalFile = formData.document;
                const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                const customFile = new File([originalFile], customFileName, {
                    type: originalFile.type,
                });

                console.log(File);
                formDataToSend.append("document", customFile);

            } else {
                // Convert non-file fields to strings
                formDataToSend.append(key, String(updatedFormData[key]));
            }
        }



        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {
                let res = await axios.put(
                    `${BASE_URL_PREBID}/project/invoiceUpdate/${i.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                if (res.status === 200) {
                    await getInvoiceDetails();
                    toast.dismiss(loadingToastId);
                    toast.success("Performa Invoice Finalized");
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(files[0])
        let newValue;
        if (type === "file") {
            console.log("file", files[0]);
            newValue = files.length > 0 ? files : null;
        } else {
            newValue = value;
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    return (
        <>
            <button
                title="Confirm Invoice"
                className="model-edit-button"
                onClick={handleShow}
            >
                <CheckGreen />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Proceed with Invoice Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Confirm that the content in Performa Invoice "{i.pi_invoice_number}"
                        is Finalized
                        <br />
                        <br />
                        <div className="flex-column">
                            <label htmlFor="pi_invoice_number">
                                Invoice Number:<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                name="invoice_number"
                                id="invoice_number"
                                value={formData.invoice_number}
                                onChange={handleInputChange}
                                className={`form-input ${errors.invoice_number
                                    ? "error"
                                    : inputState.invoice_number
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.invoice_number && (
                                <span className="error-message">{errors.invoice_number}</span>
                            )}
                        </div>

                        {
                            workStagesData?.length > 1 &&

                            <div className="flex-column">
                                <label
                                    htmlFor="document"
                                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    title="document"
                                >
                                    Document:
                                </label>
                                <div className={`file-upload-container flex-row justify-between file-in-upload ${errors.document ? 'error' : inputState.document ? 'success' : ''}`}>
                                    <label style={{ cursor: 'pointer' }} htmlFor="document">
                                        <CloudUpload />
                                        <span className="form-text-trasformation-uppercase" style={{ marginLeft: "20px" }}>
                                            {formData.document ? formData.document[0].name : 'No file selected'}
                                        </span>
                                    </label>
                                    <input
                                        placeholder="Document"
                                        title="document"
                                        id="document"
                                        type="file"
                                        name="document"
                                        onChange={handleInputChange}
                                        // value={formData.document}
                                        style={{ display: "none", position: "relative" }}

                                    />
                                    {/* {formData.document ? (<span className="file-clear" onClick={() => handleFileClear('document')}>
                                    Clear
                                </span>) : null} */}
                                    {errors.document && (
                                        <span className="error-message font-size-text">
                                            {errors.document}
                                        </span>
                                    )}
                                </div>
                            </div>}
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500  model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmit}
                                className="model-button   font-weight500    model-button-submit"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const EditInvoiceRequest = ({ id, getInvoiceData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitApproved = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.put(`${BASE_URL}/project/invoiceupdate/${id}/`, {
                bill_date_change: true,
                req_raised: "pending",
                req_raised_datetime: new Date().toISOString(),
                req_raised_by: `${sessionStorage.getItem(
                    "employee_id"
                )}-${sessionStorage.getItem("name")}`,
            });

            if (res.status === 200) {
                await getInvoiceData(id);
                toast.dismiss(loadingToastId);
                toast.success("Request Sent");
                setShow(false);
                // window.location.reload();
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err, loadingToastId);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Request Edit Access"
                className="upload-svg"
                onClick={handleShow}
            >
                <UpdatePencilWhite /> Requst Edit Access
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Request Edit Access</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Request Edit Access for the Performa Invoice
                        <br />
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500  model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitApproved}
                                className="model-button   font-weight500    model-button-submit"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </Modal.Body>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Modal>
        </>
    );
};

const CreditInvoice = ({ i, getInvoiceDetails }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.put(
                `${BASE_URL}/project/CreditInvoiceNoteAPI/${i.id}/`
                // {
                //     credit_invoice: true,
                // }
            );

            if (res.status === 200) {
                await getInvoiceDetails();
                try {
                    const letteremail = await axios.post(
                        `${BASE_URL}/project/SendInvoiceGenerateEmail/${i.id}/`
                    );

                    if (letteremail.status === 200) {
                        toast.dismiss(loadingToastId);
                        toast.success("Credit Invoice Confirmed");
                        setShow(false);
                    }
                } catch (error) {
                    console.error(error);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Credit Invoice"
                className="model-delete-button"
                onClick={handleShow}
            >
                <CrossRed />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Credit Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to Credit Invoice : "{i.invoice_number}"
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500  model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmit}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </Modal.Body>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Modal>
        </>
    );
};

const CreditInvoiceEmail = ({ i, getInvoiceDetails }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const res = await axios.post(
                `${BASE_URL}/project/SendInvoiceGenerateEmail/${i.id}/`
            );

            if (res.status === 200) {
                toast.dismiss(loadingToastId);
                toast.success("Email Sent");
                setShow(false);
                if (typeof getInvoiceDetails === "function") {
                    getInvoiceDetails();
                }
            } else {
                alert("Unexpected server response.");
            }
        } catch (err) {
            console.error(err);
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Send Mail"
                className="model-email-button"
                onClick={handleShow}
            >
                <MailIcon />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Send Mail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Send Message to Client For : "{i.invoice_number}"
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500  model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmit}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const UpdatePerformaInvoiceStatus = ({ getInvoice, i }) => {
    // let { id } = useParams();

    console.log("billing date ");

    console.log(`${i?.invoice?.id}`);

    //   ****************   Modal Section
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false); //loading logic
    const [formData, setFormData] = useState({
        pi_invoice_number: "",
        performa_invoice_status: "approved",
    });
    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = ["pi_invoice_number"];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(
                    `${BASE_URL_PREBID}/project/invoiceUpdate/${i?.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getInvoice();
                    setShow(false);
                } else {
                    // alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {
            console.log("Form contains errors:", errors);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                className="text-button"
                style={{ margin: "0 20px" }}
                onClick={handleShow}
            >
                <svg
                    width="20"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18 2L22 6M2 22L3.2764 17.3199C3.35968 17.0145 3.40131 16.8619 3.46523 16.7195C3.52199 16.5931 3.59172 16.4729 3.67332 16.3609C3.76521 16.2348 3.87711 16.1229 4.1009 15.8991L14.4343 5.56569C14.6323 5.36768 14.7313 5.26867 14.8455 5.23158C14.9459 5.19895 15.0541 5.19895 15.1545 5.23158C15.2687 5.26867 15.3677 5.36768 15.5657 5.56569L18.4343 8.43431C18.6323 8.63232 18.7313 8.73133 18.7684 8.84549C18.8011 8.94591 18.8011 9.05409 18.7684 9.15451C18.7313 9.26867 18.6323 9.36768 18.4343 9.56569L8.1009 19.8991C7.87711 20.1229 7.76521 20.2348 7.63908 20.3267C7.52709 20.4083 7.40692 20.478 7.28052 20.5348C7.13815 20.5987 6.98548 20.6403 6.68014 20.7236L2 22Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>{" "}
                Generate Invoice
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">
                        Generate Performa Invoice{" "}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                    <div className="modal-body-padding justify-center">
                        <form className="">
                            <div className="form-flex-wrap">
                                <div className="flex-column">
                                    <label className="form-labels">
                                        Invoice Number <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="pi_invoice_number"
                                        value={formData.pi_invoice_number}
                                        placeholder="Write Invoice Number"
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.pi_invoice_number
                                            ? "error"
                                            : inputState.pi_invoice_number
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.pi_invoice_number && (
                                        <span className="error-message">
                                            {errors.pi_invoice_number}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="button-models">
                                <button
                                    onClick={handleSubmit}
                                    className="model-button model-button-submit"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ProjectPerformaInvoicesDetailsTable = ({
    projectID,
    client,
    clientwiseID,
    associated,
}) => {
    const [buffer, setBuffering] = useState(false);
    const [allWorkStagesStats, setAllWorkstagesStatus] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const role = sessionStorage.getItem("role");
    const [workStagesData, setWorkStagesData] = useState([]);
    useEffect(() => {
        if (client) {
            getWorkStagesData();
        }
    }, [client]);

    const getWorkStagesData = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL_PREBID}/project/workstagesbyprojectDetail/${clientwiseID}/`
            );
            setWorkStagesData(res.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };
    useEffect(() => {
        if (client) {
            getInvoiceDetails();
        }
    }, [client]);

    const getInvoiceDetails = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/project/invoicebyproject/${clientwiseID}/`
            );
            setFilteredData(res.data);
            const ress = await axios.get(
                `${BASE_URL}/project/pendingforInvoiceforaccount/${clientwiseID}/`
            );
            setAllWorkstagesStatus(ress.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const baseUrl2 = "/" + urlParts[3] + `/invoiceSlip`;
    const baseUrl3 = "/" + urlParts[3] + `/performainvoiceslip`;
    const invoicePage = (pr_code) => {
        navigate(baseUrl2 + `/${pr_code}/`);
    };
    const performainvoicePage = (pr_code) => {
        navigate(baseUrl3 + `/${pr_code}/`);
    };

    const department = sessionStorage.getItem("department");

    return (
        <>
            <div className="table-css-white-background">
                {/* <div className="attendance-box"> */}
                <div className="heading-bg-color-white">
                    <div className="jd-heading-outer-flex ">
                        <h2 className="jd-heading-main font-weight600  font-size-heading">
                            {filteredData.length > 1
                                ? "Performa Invoices"
                                : "Performa Invoice"}
                        </h2>
                        <div className="field-cont">
                            {/* <div>{allWorkStagesStats.length >= 0 ? "" : department === "Accounts" ? <Invoice id={clientwiseID} getInvoiceDetails={getInvoiceDetails} /> : null}</div> */}
                            {/* Need to check this condition */}
                            <div>
                                {allWorkStagesStats >= 0 ? (
                                    ""
                                ) : department === "Accounts" ? (
                                    <Invoice
                                        id={clientwiseID}
                                        getInvoiceDetails={getInvoiceDetails}
                                    // workStagesData={workStagesData}
                                    />
                                ) : null}
                            </div>
                            {/* <Invoice id={clientwiseID} /> */}
                        </div>
                    </div>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                <div className="datagrid-container">
                    <div className="invoice-table">
                        <div className="invoice-table2 ">
                            <table className="project-details-table">
                                <thead>
                                    <tr className="custom-table-head-trr">
                                        <th className="align-center ">Sr no.</th>
                                        <th className="align-center ">Performa Invoice No.</th>
                                        {/* <th className="align-center ">Project Name</th> */}
                                        <th className="align-center ">Client Name</th>
                                        <th className="align-center ">Work Order Amount</th>
                                        <th className="align-center ">GST</th>
                                        <th className="align-center ">Total Amount</th>
                                        <th className="align-center ">Billing Percentage</th>
                                        <th className="align-center ">Billing Amount</th>
                                        {/* <th className="align-center ">Balance to bill</th>  */}
                                        {/* <th className="align-center ">Received Date</th>
                                        <th className="align-center ">Received Amount</th> */}
                                        <th className="align-center ">Performa Invoice</th>
                                        {/* <th className="align-center ">View Invoice</th> */}
                                        {/* <th className="align-center ">View Perfoma Invoice</th> */}
                                        {/* <th className="align-center ">Add Received Amt.</th> */}
                                        {/* <th className="align-center ">Delete Invoice</th> */}
                                        <th className="align-right ">Actions</th>
                                    </tr>
                                </thead>

                                {buffer ? (
                                    <Loader /> //buffering logic
                                ) : (
                                    <tbody>
                                        {filteredData
                                            .sort((a, b) =>
                                                a.client_name?.localeCompare(b.client_name, "en", {
                                                    ignorePunctuation: true,
                                                })
                                            )

                                            .map((i, index) => (
                                                <React.Fragment key={index}>
                                                    <tr className="tr-border-bottom">
                                                        <td colSpan="8"></td>
                                                    </tr>
                                                    <tr className="custom-table-head-tddd font-weight500 font-size-label" style={{ background: i?.credit_note ? " rgb(255, 116, 124,0.1)" : '' }}>
                                                        <td className="align-center ">{index + 1}</td>
                                                        <td className="align-center ">
                                                            {i?.pi_invoice_number}
                                                        </td>
                                                        {/* <td className="align-center ">{i.project_name} </td> */}
                                                        <td className="align-center ">
                                                            {i.client_name}
                                                            <br />
                                                            {i.contact_number}
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(
                                                                i.project_without_gst_amount
                                                            )}
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(i.project_gst_amount)}
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(i.project_woamount)}
                                                        </td>
                                                        <td className="align-center ">
                                                            {i.bill_percentage}%
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(i.billamount)}
                                                        </td>
                                                        {/* <td className="align-center ">{i.woamount - i.received_amount}</td> */}
                                                        {/* <td className="align-center ">{i.rec_date != null ? formattedDateLong(i.rec_date) : ""}</td>
                                                        <td className="align-center ">{formatCurrencyIndian(i.amount_recived)}</td> */}
                                                        <td className="align-center ">
                                                            <button
                                                                className="models-button model-add"
                                                                title="View Performa Invoice"
                                                                onClick={(e) => performainvoicePage(i.id)}
                                                            >
                                                                <Reciept />
                                                            </button>
                                                        </td>
                                                        {/* <td className="align-center ">
                                                            {i.invoice_confirmation ?
                                                                <button className=""
                                                                    onClick={(e) => invoicePage(i.id)}
                                                                >
                                                                    <Eye />
                                                                </button>
                                                                :
                                                                <>
                                                                    Confirm Invoice First
                                                                    <ConfirmInvoice
                                                                        i={i}
                                                                        getInvoiceDetails={getInvoiceDetails}
                                                                    />
                                                                </>
                                                            }

                                                        </td> */}
                                                        {/* <td className="align-center">
                                                            <button className="models-button model-add" onClick={(e) => performainvoicePage(i.id)}>
                                                                <Eye />
                                                            </button>
                                                        </td> */}
                                                        {/* <td className="align-center">
                                                            <ReceivedAmount id={i.id} maxlimitreceive={i.billamount} />
                                                        </td> */}
                                                        <td className="align-right flex-row">
                                                            {/* <ConfirmInvoice
                                                                i={i}
                                                                getInvoiceDetails={getInvoiceDetails}
                                                            /> */}
                                                            <div
                                                                className="flex-row align-right"
                                                                style={{ justifyContent: "end" }}
                                                            >
                                                                {i.invoice_confirmation ? (
                                                                    i?.credit_note ? <label style={{ color: 'red' }}>Credit Note</label> :
                                                                        <CreditInvoiceEmail
                                                                            i={i}
                                                                            getInvoiceDetails={getInvoiceDetails}
                                                                        />
                                                                ) : (
                                                                    <ConfirmInvoice
                                                                        i={i}
                                                                        getInvoiceDetails={getInvoiceDetails}
                                                                        workStagesData={workStagesData}
                                                                    />
                                                                )}

                                                                {i.invoice_number === "" ? (
                                                                    <UpdatePerformaInvoiceStatus
                                                                        i={i}
                                                                        getInvoice={getInvoiceDetails}
                                                                    />
                                                                ) : // null
                                                                    associated === true ? (
                                                                        !i.invoice_number && (
                                                                            <DeleteInvoice
                                                                                i={i}
                                                                                id={i.id}
                                                                                getInvoiceData={getInvoiceDetails}
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        (sessionStorage.getItem(
                                                                            "delete_project_access"
                                                                        ) === "true" ||
                                                                            department === "Accounts") &&
                                                                        !i.invoice_number && (
                                                                            <DeleteInvoice
                                                                                i={i}
                                                                                id={i.id}
                                                                                getInvoiceData={getInvoiceDetails}
                                                                            />
                                                                        )
                                                                    )}
                                                            </div>
                                                            {/* <div className="flex-row justify-evenly">

                                                            </div> */}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </>
    );
};

const ProjectInvoicesDetailsTable = ({
    projectID,
    client,
    clientwiseID,
    associated,
}) => {
    const [buffer, setBuffering] = useState(false);
    const [allWorkStagesStats, setAllWorkstagesStatus] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const role = sessionStorage.getItem("role");

    useEffect(() => {
        if (client) {
            getInvoiceDetails();
        }
    }, [client]);

    const getInvoiceDetails = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/project/invoicebyproject/${clientwiseID}/`
            );
            setFilteredData(res.data);
            const ress = await axios.get(
                `${BASE_URL}/project/pendingforInvoiceforaccount/${clientwiseID}/`
            );
            setAllWorkstagesStatus(ress.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const baseUrl2 = "/" + urlParts[3] + `/invoiceSlip`;
    const baseUrl3 = "/" + urlParts[3] + `/performainvoiceslip`;
    const invoicePage = (pr_code) => {
        navigate(baseUrl2 + `/${pr_code}/`);
    };
    const performainvoicePage = (pr_code) => {
        navigate(baseUrl3 + `/${pr_code}/`);
    };

    const department = sessionStorage.getItem("department");

    return (
        <>
            <div className="table-css-white-background">
                {/* <div className="attendance-box"> */}
                <div className="heading-bg-color-white">
                    <div className="jd-heading-outer-flex ">
                        <h2 className="jd-heading-main font-weight600  font-size-heading">
                            {filteredData.length > 1 ? "Tax Invoices" : "Tax Invoice"}{" "}
                        </h2>
                        <div className="field-cont">
                            {/* <div>{allWorkStagesStats >= 0 ? "" : department === "Accounts" ? <Invoice id={clientwiseID} getInvoiceDetails={getInvoiceDetails} /> : null}</div>
               */}
                        </div>
                    </div>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                <div className="datagrid-container">
                    <div className="invoice-table">
                        <div className="invoice-table2 ">
                            <table className="project-details-table">
                                <thead>
                                    <tr className="custom-table-head-trr">
                                        <th className="align-center ">Sr no.</th>
                                        <th className="align-center ">Invoice No.</th>
                                        {/* <th className="align-center ">Project Name</th> */}
                                        <th className="align-center ">Client Name</th>
                                        <th className="align-center ">Work Order Amount</th>
                                        <th className="align-center ">GST</th>
                                        <th className="align-center ">Total Amount</th>
                                        <th className="align-center ">Billing Percentage</th>
                                        <th className="align-center ">Billing Amount</th>
                                        {/* <th className="align-center ">Balance to bill</th>  */}
                                        {/* <th className="align-center ">Received Date</th>
                                        <th className="align-center ">Received Amount</th> */}
                                        {/* <th className="align-center ">Performa Invoice</th> */}
                                        <th className="align-center ">View Invoice</th>
                                        {/* <th className="align-center ">View Perfoma Invoice</th> */}
                                        {/* <th className="align-center ">Add Received Amt.</th> */}
                                        {/* <th className="align-center ">Delete Invoice</th> */}
                                        <th className="align-center ">Actions</th>
                                    </tr>
                                </thead>

                                {buffer ? (
                                    <Loader /> //buffering logic
                                ) : (
                                    <tbody>
                                        {filteredData
                                            .sort((a, b) =>
                                                a.client_name?.localeCompare(b.client_name, "en", {
                                                    ignorePunctuation: true,
                                                })
                                            )

                                            .map((i, index) => (
                                                <React.Fragment key={index}>
                                                    <tr className="tr-border-bottom">
                                                        <td colSpan="8"></td>
                                                    </tr>
                                                    <tr className="custom-table-head-tddd font-weight500 font-size-label">
                                                        <td className="align-center ">{index + 1}</td>
                                                        <td className="align-center ">
                                                            {i.invoice_number}
                                                        </td>
                                                        {/* <td className="align-center ">{i.project_name} </td> */}
                                                        <td className="align-center ">
                                                            {i.client_name}
                                                            <br />
                                                            {i.contact_number}
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(
                                                                i.project_without_gst_amount
                                                            )}
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(i.project_gst_amount)}
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(i.project_woamount)}
                                                        </td>
                                                        <td className="align-center ">
                                                            {i.bill_percentage}%
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(i.billamount)}
                                                        </td>
                                                        {/* <td className="align-center ">{i.woamount - i.received_amount}</td> */}
                                                        {/* <td className="align-center ">{i.rec_date != null ? formattedDateLong(i.rec_date) : ""}</td>
                                                        <td className="align-center ">{formatCurrencyIndian(i.amount_recived)}</td> */}
                                                        {/* <td className="align-center ">
                                                            <button className="models-button model-add" title="View Performa Invoice"
                                                                onClick={(e) => performainvoicePage(i.id)}
                                                            >
                                                                <Reciept />
                                                            </button>
                                                        </td> */}
                                                        <td className="align-center ">
                                                            {i.invoice_confirmation ? (
                                                                <button
                                                                    className=""
                                                                    onClick={(e) => invoicePage(i.id)}
                                                                >
                                                                    <Eye />
                                                                </button>
                                                            ) : (
                                                                // <>
                                                                //     Confirm Invoice First
                                                                //     <ConfirmInvoice
                                                                //         i={i}
                                                                //         getInvoiceDetails={getInvoiceDetails}
                                                                //     />
                                                                // </>
                                                                " Confirm Invoice First"
                                                            )}
                                                        </td>
                                                        {/* <td className="align-center">
                                                            <button className="models-button model-add" onClick={(e) => performainvoicePage(i.id)}>
                                                                <Eye />
                                                            </button>
                                                        </td> */}
                                                        {/* <td className="align-center">
                                                            <ReceivedAmount id={i.id} maxlimitreceive={i.billamount} />
                                                        </td> */}
                                                        <td className="">
                                                            <div className="flex-row justify-evenly">
                                                                {i.invoice_confirmation ? (
                                                                    i.credit_note ? (
                                                                        <p style={{ color: "red" }}>
                                                                            Credit Note
                                                                        </p>
                                                                    ) : (
                                                                        <CreditInvoice
                                                                            i={i}
                                                                            getInvoiceDetails={getInvoiceDetails}
                                                                        />
                                                                    )
                                                                ) : associated === true ? (
                                                                    <DeleteInvoice
                                                                        i={i}
                                                                        id={i.id}
                                                                        getInvoiceData={getInvoiceDetails}
                                                                    />
                                                                ) : (
                                                                    (sessionStorage.getItem(
                                                                        "delete_project_access"
                                                                    ) === "true" ||
                                                                        department === "Accounts") && (
                                                                        <DeleteInvoice
                                                                            i={i}
                                                                            id={i.id}
                                                                            getInvoiceData={getInvoiceDetails}
                                                                        />
                                                                    )
                                                                )}
                                                            </div>
                                                            {/* <div className="flex-row justify-evenly">

                                                            </div> */}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </>
    );
};

const AddPaymentRecord = ({ id, invoiceList, getInvoicePayments }) => {
    const [show, setShow] = useState(false);
    const [filteredData, setFilteredData] = useState();
    // const [invoiceList, setInvoiceList] = useState([]);

    const handleClose = () => {
        setFormData({
            multiple_invoice: [],
            payment_id: "",
            amount: "",
            payment_date: "",
            transaction_amount: "",
            payment_method: "",
            status: "",
            description: "",
            uploaded_file: null,
            payment_method: "cash",
        });

        setShow(false);
    };
    const handleShow = async () => {
        setShow(true);
        // try {
        //     const res = await axios.get(`${BASE_URL}/project/invoicebyproject/${id}/`);
        //     setInvoiceList(res.data);

        // } catch (err) {
        // } finally {

        // }
    };

    const [formData, setFormData] = useState({
        // invoice: '',
        multiple_invoice: [],
        payment_id: "",
        amount: "",
        payment_date: "",
        payment_method: "bank_transfer",
        status: "completed",
        description: "",
        uploaded_file: null,
        payment_method: "cash",
        transaction_amount: "",
    });

    console.log(invoiceList);

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            // 'invoice',
            "multiple_invoice",
            "payment_id",
            "amount",
            "payment_date",
            "transaction_amount",
            "description",
            "uploaded_file",
            "payment_method",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            setLoading(true); //loading logic

            const updatedformData = new FormData();
            // Append all other fields
            Object.keys(formData).forEach((key) => {
                if (key === "multiple_invoice" && Array.isArray(formData[key])) {
                    // Append each value of multiple_invoice as a separate field
                    formData[key].forEach((invoiceId) => {
                        updatedformData.append("multiple_invoice", invoiceId);
                    });
                } else if (key !== "uploaded_file" && formData[key]) {
                    updatedformData.append(key, formData[key]);
                }
            });

            const symbols = "!@#$%^&*()_-+=";
            const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
            const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const numbers = "0123456789";
            const now = new Date();
            const date = now
                .toLocaleDateString("en-GB")
                .split("/")
                .reverse()
                .join("-"); // Format: YYYY-MM-DD
            const time = now
                .toLocaleTimeString("en-GB", { hour12: false })
                .replace(/:/g, "-"); // Format: HH-MM-SS
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = "";
            for (let i = 0; i < 8; i++) {
                const randomIndex = Math.floor(Math.random() * allChars.length);
                randomCode += allChars[randomIndex];
            }
            const originalFile = formData.uploaded_file;
            const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
            const customFile = new File([originalFile], customFileName, {
                type: originalFile.type,
            });
            updatedformData.append("uploaded_file", customFile);

            try {
                let res = await axios.post(
                    `${BASE_URL_PREBID}/project/paymentreciept/`,
                    updatedformData
                );

                if (res.status === 200) {
                    await getInvoicePayments();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        const allowedTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "image/jpeg",
            "image/png",
        ];

        if (file) {
            if (allowedTypes.includes(file.type)) {
                setFormData({
                    ...formData,
                    [name]: file,
                });
                setErrors({
                    ...errors,
                    [name]: null,
                });
            } else {
                setErrors({
                    ...errors,
                    [name]:
                        "Invalid file type. Please select a valid file (PDF, DOC, DOCX, JPG, JPEG, PNG).",
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: null,
            });
            setErrors({
                ...errors,
                [name]: null,
            });
        }
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const options = invoiceList
        .sort((a, b) => parseInt(a.invoice_number) - parseInt(b.invoice_number))
        .map((e) => ({
            value: e.id,
            label: `${e.invoice_number}`,
        }));

    const handleChangeMultipleInvoiceTo = (selected) => {
        const multiple_invoice = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            multiple_invoice, // Ensure this is always an array
        }));
    };

    const [totalBillAmount, setTotalBillAmount] = useState(0);
    const [gstAmount, setGstAmount] = useState(0);
    const [baseAmount, setBaseAmount] = useState(0);

    useEffect(() => {
        const selectedBillAmounts = invoiceList
            .filter((invoice) => formData.multiple_invoice.includes(invoice.id))
            .map((invoice) => parseFloat(invoice.billamount || 0));
        const total = selectedBillAmounts.reduce((sum, amount) => sum + amount, 0);
        setTotalBillAmount(total);
        const selectedGstAmount = invoiceList.filter((invoice) =>
            formData.multiple_invoice.includes(invoice.id)
        ).map((invoice) => parseFloat(invoice.gst_amount || 0));
        setGstAmount(selectedGstAmount.reduce((sum, amount) => sum + amount, 0));
        const selectedBaseAmount = invoiceList.filter((invoice) =>
            formData.multiple_invoice.includes(invoice.id)
        ).map((invoice) => parseFloat(invoice.wihoutgst_amount || 0));
        setBaseAmount(selectedBaseAmount.reduce((sum, amount) => sum + amount, 0));
        formData.amount = selectedBaseAmount.reduce((sum, amount) => sum + amount, 0);
    }, [formData.multiple_invoice, invoiceList]);

    console.log(totalBillAmount);

    return (
        <>
            <button
                title="Raise Payment"
                onClick={handleShow}
                className="upload-svg "
            >
                <AddwithWhiteCircle /> Payment Reciept
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="dialog-modal-assign-task dialog-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Add Transaction Records</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                    <div className="modal-body-padding">
                        <form>
                            <div className="form-flex-wrap">
                                <div className="flex-column form-group-select">
                                    <label className="form-labels">
                                        Associate Invoice:<span className="required">*</span>
                                    </label>

                                    <Select
                                        options={options}
                                        isMulti
                                        onChange={handleChangeMultipleInvoiceTo}
                                        value={formData.multiple_invoice?.map((code) => ({
                                            value: code,
                                            label:
                                                options.find((opt) => opt.value === code)?.label ||
                                                code,
                                        }))}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: "34vw",
                                                height: "50px",
                                                borderRadius: "10px",
                                                border: "1px solid #e3e3e3",
                                                margin: "10px 0px 3px ",
                                                color: "#4a4a4a",
                                                backgroundColor: "#f7f8fa",
                                                padding: "0px 10px",
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                color: "#4a4a4a",
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                borderRadius: "10px",
                                                marginTop: "0",
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: "#4a4a4a",
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: "#4a4a4a",
                                            }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                height: "15px",
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "10px 15px",
                                                color: state.isSelected ? "white" : "#707070",
                                                backgroundColor: state.isSelected ? "#2576bc" : "white",
                                                cursor: "pointer",
                                                "&:hover": {
                                                    backgroundColor: "#2576bc",
                                                    color: "white",
                                                },
                                            }),
                                        }}
                                    />

                                    {errors.multiple_invoice && (
                                        <span className="error-message font-size-text ">
                                            {errors.multiple_invoice}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Base Amount:<span className="required">*</span>
                                    </label>
                                    <input
                                        value={baseAmount || ""}
                                        className={`form-input`}
                                        readOnly
                                    />
                                    {errors.amount && (
                                        <span className="error-message">{errors.amount}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        GST:<span className="required">*</span>
                                    </label>

                                    <input
                                        // type="date"

                                        value={gstAmount || ""}
                                        className={`form-input`}
                                        readOnly
                                    />
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Invoice Amount:<span className="required">*</span>
                                    </label>

                                    <input
                                        // type="date"

                                        value={totalBillAmount || ""}
                                        className={`form-input ${errors.totalBillAmount
                                            ? "error"
                                            : inputState.totalBillAmount
                                                ? "success"
                                                : ""
                                            }`}
                                        readOnly
                                    />
                                </div>

                                {/* <div className="flex-column form-group-select">
                                    <label className="form-labels">Invoice:<span className="required">*</span></label>
                                    <select
                                        name="invoice"
                                        value={formData.invoice}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.invoice ? 'error' : inputState.invoice ? 'success' : ''}`}
                                    >
                                        <option value="">Select a Invoice</option>
                                        {invoiceList.map((invoice) => (
                                            <option key={invoice.id} value={invoice.id}>{invoice.invoice_number}</option>
                                        ))}
                                    </select>
                                    <DropdownArrow />
                                    {errors.invoice && <span className="error-message">{errors.invoice}</span>}
                                </div> */}
                                <div className="flex-column">
                                    <label className="form-labels">
                                        Transaction Date:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        name="payment_date"
                                        value={formData.payment_date || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.payment_date
                                            ? "error"
                                            : inputState.payment_date
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.payment_date && (
                                        <span className="error-message">{errors.payment_date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Transaction ID:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="payment_id"
                                        placeholder="Transaction ID"
                                        value={formData.payment_id || ""}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.payment_id
                                            ? "error"
                                            : inputState.payment_id
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.payment_id && (
                                        <span className="error-message">{errors.payment_id}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Transaction Amount:<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="transaction_amount"
                                        min={0}
                                        placeholder="0"
                                        step=""
                                        value={formData.transaction_amount || ""}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.transaction_amount ? "error" : inputState.transaction_amount ? "success" : ""
                                            }`}
                                    />
                                    {errors.transaction_amount && (
                                        <span className="error-message">{errors.transaction_amount}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        TDS:
                                    </label>
                                    <input
                                        type="number"
                                        name="tds"
                                        min={0}
                                        placeholder="0"
                                        step=""
                                        value={formData.tds || ""}
                                        onChange={handleInputChange}
                                        onWheel={(e) => e.target.blur()}
                                        className={`form-input ${errors.tds ? "error" : inputState.tds ? "success" : ""
                                            }`}
                                    />
                                    {errors.tds && (
                                        <span className="error-message">{errors.tds}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Payment Method:<span className="required">*</span>
                                    </label>
                                    <select
                                        type="text"
                                        name="payment_method"
                                        value={formData.payment_method}
                                        onChange={handleInputChange}
                                        className="form-input"
                                    >
                                        <option value="cash">Cash</option>
                                        <option value="credit_card">Credit Card</option>
                                        <option value="paypal">Paypal</option>
                                        <option value="bank_transfer">Bank Transfer</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                {/* <div className="flex-column form-group-select">
                                    <label className="form-labels">Payment Method:<span className="required">*</span></label>
                                    <select
                                        name="payment_method"
                                        value={formData.payment_method || ""}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.payment_method ? 'error' : inputState.payment_method ? 'success' : ''}`}
                                    >
                                        <option value="">Select a Payment Method</option>
                                        <option value="credit_card">Credit Card</option>
                                        <option value="paypal">Paypal</option>
                                        <option value="bank_transfer">Bank Transfer</option>
                                        <option value="cash">Cash</option>
                                        <option value="other">Other</option>
                                    </select>
                                    
                                    {errors.payment_method && <span className="error-message">{errors.payment_method}</span>}
                                </div> */}

                                {/* <div className="flex-column form-group-select">
                                    <label className="form-labels">Status:<span className="required">*</span></label>
                                    <select
                                        name="status"
                                        value={formData.status || ""}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.status ? 'error' : inputState.status ? 'success' : ''}`}
                                    >
                                        <option value="">Select a Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="inprogress">In Progress</option>
                                        <option value="failed">Failed</option>
                                        <option value="completed">Completed</option>
                                        <option value="hold">Hold</option>
                                    </select>
                              
                                    {errors.status && <span className="error-message">{errors.status}</span>}
                                </div> */}

                                <div className="flex-column">
                                    <label className="form-labels">
                                        Description:<span className="required">*</span>
                                    </label>
                                    <textarea
                                        type="text"
                                        name="description"
                                        placeholder="Description"
                                        value={formData.description || ""}
                                        onChange={handleInputChange}
                                        className={`form-input-textarea-h ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message">{errors.description}</span>
                                    )}
                                </div>

                                <div className="flex-column ">
                                    <label className="form-labels">
                                        Attachment(PDF):<span className="required">*</span>
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in ${errors.uploaded_file
                                            ? "error"
                                            : inputState.uploaded_file
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <label
                                            style={{ cursor: "pointer" }}
                                            htmlFor="uploaded_file"
                                        >
                                            <CloudUpload />
                                            <span
                                                className="form-text-trasformation-uppercase"
                                                style={{ marginLeft: "20px" }}
                                            >
                                                {formData.uploaded_file
                                                    ? formData.uploaded_file.name
                                                    : "No file selected"}
                                            </span>
                                        </label>
                                        <input
                                            type="file"
                                            id="uploaded_file"
                                            name="uploaded_file"
                                            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
                                            onChange={handleFileChange}
                                            style={{ display: "none", position: "relative" }}
                                        />
                                        {formData.uploaded_file ? (
                                            <span
                                                className="file-clear"
                                                onClick={() => handleFileClear("uploaded_file")}
                                            >
                                                Clear
                                            </span>
                                        ) : null}
                                    </div>
                                    {errors.uploaded_file && (
                                        <span className="error-message">
                                            {errors.uploaded_file}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="button-models">
                                <button
                                    onClick={handleSubmit}
                                    className="model-button model-button-submit"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteInvoicePayment = ({ i, id, getInvoiceData }) => {
    const [show, setShow] = useState(false);

    const [loading, setLoading] = useState(false); //loading logic// console.log(id)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        setLoading(true); // loading logic
        try {
            console.log("Delete Expense Detail Api");
            let res = await axios.delete(
                `${BASE_URL_PREBID}/project/paymentreciept/${id}/`
            );

            if (res.status === 200) {
                await getInvoiceData();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            if (err.response) {
                toast.dismiss(loadingToastId);
                const errorData = err.response.data;

                if (typeof errorData.error === "string") {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === "object" && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach((message) =>
                            toast.error(`"${field}": ${message}`)
                        );
                    });
                } else {
                    toast.error("Error:- Failed to Process!");
                }
            } else {
                toast.error("Error processing your request.");
            }
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are You Sure, You want to Delete details of Payment ID :{" "}
                    {i.payment_id}
                    <div className="button-models">
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ProjectInvoicesPaymentsTable = ({
    projectID,
    client,
    clientwiseID,
    associated,
}) => {
    const [buffer, setBuffering] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [paymentData, setPaymentData] = useState([]);

    useEffect(() => {
        if (client) {
            getPaymentDetails();
        }
    }, [client]);

    const getPaymentDetails = async () => {
        setBuffering(true);
        try {
            const invoice = await axios.get(
                `${BASE_URL_PREBID}/project/invoicebyproject/${clientwiseID}/`
            );
            setInvoiceList(invoice.data);

            const payment = await axios.get(
                `${BASE_URL_PREBID}/project/paymentReceiptfilterAPI/${clientwiseID}/`
            );
            setPaymentData(payment.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const baseUrl2 = "/" + urlParts[3] + `/invoiceSlip`;
    const invoicePage = (pr_code) => {
        navigate(baseUrl2 + `/${pr_code}/`);
    };

    return (
        <>
            <div className="table-css-white-background">
                {/* <div className="attendance-box"> */}
                <div className="heading-bg-color-white">
                    <div className="jd-heading-outer-flex ">
                        <h2 className="jd-heading-main font-weight600  font-size-heading">
                            Payments Recieved
                        </h2>
                        <div className="field-cont">
                            {associated === true ? (
                                <AddPaymentRecord
                                    id={clientwiseID}
                                    invoiceList={invoiceList}
                                    getInvoicePayments={getPaymentDetails}
                                />
                            ) : (
                                sessionStorage.getItem("edit_project_access") === "true" && (
                                    <AddPaymentRecord
                                        id={clientwiseID}
                                        invoiceList={invoiceList}
                                        getInvoicePayments={getPaymentDetails}
                                    />
                                )
                            )}
                        </div>
                    </div>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                <div className="datagrid-container">
                    <div className="invoice-table">
                        <div className="invoice-table2 ">
                            <table className="project-details-table">
                                <thead>
                                    <tr className="custom-table-head-trr">
                                        <th className="align-center ">Sr no.</th>
                                        <th className="align-left ">Ref. Invoices</th>
                                        <th className="align-center ">Payment ID</th>
                                        <th className="align-center ">Payment Date</th>
                                        <th className="align-center ">Amount</th>
                                        <th className="align-center ">TDS</th>

                                        <th className="align-center ">Payment Method</th>
                                        <th className="align-center ">Status</th>
                                        <th className="align-center ">Description</th>
                                        <th className="align-center ">Attachment</th>
                                        <th className="align-center ">Action</th>
                                    </tr>
                                </thead>
                                {buffer ? (
                                    <Loader /> //buffering logic
                                ) : (
                                    <tbody>
                                        {paymentData
                                            .sort((a, b) =>
                                                a.client_name?.localeCompare(b.client_name, "en", {
                                                    ignorePunctuation: true,
                                                })
                                            )
                                            .map((i, index) => (
                                                <React.Fragment key={index}>
                                                    <tr className="tr-border-bottom">
                                                        <td colSpan="8"></td>
                                                    </tr>
                                                    <tr className="custom-table-head-tddd font-weight500 font-size-label">
                                                        <td className="align-center ">{index + 1}</td>
                                                        {/* <td className="align-center ">{i.invoice_number}</td> */}
                                                        <td className="text-left ">
                                                            <ul
                                                                style={{
                                                                    listStyleType: "none",
                                                                    padding: 0,
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                {i.invoice_details?.map((items) => (
                                                                    <li key={items.invoice_number}>
                                                                        {items.invoice_number}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </td>
                                                        <td className="align-center ">{i.payment_id}</td>
                                                        <td className="align-center ">
                                                            {i.payment_date != null
                                                                ? formattedDateLong(i.payment_date)
                                                                : ""}
                                                        </td>
                                                        {/* <td className="align-center " style={{ display: "flex" }}> */}
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(i.amount)}
                                                        </td>
                                                        <td className="align-center ">
                                                            {formatCurrencyIndian(i.tds)}
                                                        </td>
                                                        <td className="align-center ">
                                                            {i.payment_method}
                                                        </td>
                                                        <td className="align-center ">{i.status}</td>
                                                        <td className="align-center ">{i.description}</td>

                                                        {/* </td> */}
                                                        <td className="align-center ">
                                                            {i.uploaded_file ? (
                                                                <>
                                                                    <a
                                                                        href={i.uploaded_file}
                                                                        target="blank"
                                                                        className="model-button width-5vw"
                                                                    >
                                                                        <Attachment />
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>
                                                        <td className="align-center">
                                                            {/* <ReceivedAmount id={i.id} maxlimitreceive={i.billamount} /> */}
                                                            {associated === true ? (
                                                                <DeleteInvoicePayment
                                                                    i={i}
                                                                    id={i.id}
                                                                    getInvoiceData={getPaymentDetails}
                                                                />
                                                            ) : (
                                                                sessionStorage.getItem(
                                                                    "delete_project_access"
                                                                ) === "true" && (
                                                                    <DeleteInvoicePayment
                                                                        i={i}
                                                                        id={i.id}
                                                                        getInvoiceData={getPaymentDetails}
                                                                    />
                                                                )
                                                            )}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </>
    );
};

const AddSubmissionDocuments = ({
    projectID,
    clientwiseID,
    getSubmissionDetails,
    workstageId,
}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {

        setShow(false);
        setFormData({
            projectdetailsclientwise: clientwiseID,
            workstage: workstageId || "",
            document_name: "",
            file: "",
        })
    }
    const handleShow = () => {
        if (workstageId) {
            setFormData({
                ...formData,
                workstage: workstageId,
            });
        }
        getClientDetails();
        setShow(true);
    };

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const [formData, setFormData] = useState({
        projectdetailsclientwise: clientwiseID,
        workstage: workstageId || "",
        document_name: "",
        file: "",
    });

    const [inputFields, setInputFields] = useState([
        {
            workStages: "",
            percentage: "",
            completed: false,
            invoice_generated: false,
            project_detail: clientwiseID,
        },
    ]);

    const getClientDetails = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${BASE_URL_PREBID}/project/workstagesbyprojectDetail/${clientwiseID}/`
            );
            setInputFields(
                res.data.length > 0
                    ? res.data
                    : [
                        {
                            workStages: "",
                            percentage: "",
                            completed: false,
                            invoice_generated: false,
                            project_detail: clientwiseID,
                        },
                    ]
            );
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
        }
    };

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["workstage", "document_name", "file"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const formDataa = new FormData();
            formDataa.append("document_name", formData.document_name);
            formDataa.append("file", formData.file);
            formDataa.append(
                "projectdetailsclientwise",
                formData.projectdetailsclientwise
            );
            formDataa.append("workstage", formData.workstage);
            try {
                let res = await axios.post(`${BASE_URL}/project/document/`, formDataa, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res.status === 200) {
                    try {
                        let res2 = await axios.post(`${BASE_URL}/project/SendDocumentMailAPI/${res.data.id}/`, {});

                        if (res2.status === 200) {
                            handleClose();
                            await getSubmissionDetails();
                        } else {
                            // alert(res);
                        }
                    } catch (err) {
                        //    handle
                    }
                } else {
                    // alert(res);
                }
            } catch (err) {
                //    handle
            } finally {
                setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            setFormData({
                ...formData,
                [name]: file,
            });
        } else {
            setFormData({
                ...formData,
                [name]: null,
            });
        }
    };


    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    console.log("formData");
    console.log(formData);
    console.log("workstageId");
    console.log(workstageId);

    return (
        <>
            <button className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle /> Document
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="modal_width_38vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">
                        Add Submission Documents
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div justify-center">
                        <div className=" ">
                            <form>
                                <div className="flex-column form-group-select">
                                    <label className="form-labels  font-weight500   font-size-heading">
                                        Work Stage:<span className="required">*</span>
                                    </label>

                                    {loading ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                name="workstage"
                                                value={formData.workstage}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.workstage
                                                    ? "error"
                                                    : inputState.workstage
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            >
                                                <option value="">Select a WorkStage</option>
                                                {inputFields.map((stage) => (
                                                    <option key={stage.wid} value={stage.wid}>
                                                        {stage.workStages}
                                                    </option>
                                                ))}
                                            </select>
                                            {/* <DropdownArrow /> */}
                                            {errors.workstage && (
                                                <span className="error-message">
                                                    {errors.workstage}
                                                </span>
                                            )}
                                        </>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="document_name"
                                        className="form-labels  font-weight500   font-size-heading"
                                    >
                                        Document Name<span className="required">*</span>
                                    </label>
                                    <input
                                        id="document_name"
                                        type="document_name"
                                        name="document_name"
                                        placeholder="Document Name"
                                        onChange={handleInputChange}
                                        value={formData.document_name}
                                        className={`form-input ${errors.document_name
                                            ? "error"
                                            : inputState.document_name
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.document_name && (
                                        <span className="error-message font-size-text ">
                                            {errors.document_name}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="attachment"
                                        className="form-labels  font-weight500   font-size-heading"
                                    >
                                        Attachment<span className="required">*</span>
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in-upload ${errors.file ? "error" : inputState.file ? "success" : ""
                                            }`}
                                    >
                                        <label
                                            className=""
                                            style={{ cursor: "pointer" }}
                                            htmlFor="file"
                                        >
                                            <CloudUpload />
                                            <span
                                                className="form-text-trasformation-uppercase"
                                                style={{ marginLeft: "20px" }}
                                            >
                                                {formData.file
                                                    ? formData.file.name
                                                    : "No file selected"}
                                            </span>
                                        </label>
                                        <input
                                            id="file"
                                            type="file"
                                            name="file"
                                            onChange={handleFileChange}
                                            style={{ display: "none", position: "relative" }}
                                        />
                                        {formData.file ? (
                                            <span
                                                className="file-clear"
                                                onClick={() => handleFileClear("file")}
                                            >
                                                Clear
                                            </span>
                                        ) : null}
                                    </div>
                                    {errors.file && (
                                        <span className="error-message font-size-text ">
                                            {errors.file}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button model-button-cancel  font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ProjectSubmissionDocumentTable = ({
    projectID,
    client,
    clientwiseID,
    associated,
}) => {
    const [buffer, setBuffering] = useState(false);
    const [submissionDocs, setSubmissionDocs] = useState([]);

    useEffect(() => {
        if (client) {
            getSubmissionDetails();
        }
    }, [client]);

    const getSubmissionDetails = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/project/documentfilterclientWise/${clientwiseID}/`
            );
            setSubmissionDocs(res.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    return (
        <>
            <div className="table-css-white-background">
                {/* <div className="attendance-box"> */}
                <div className="heading-bg-color-white">
                    <div className="jd-heading-outer-flex ">
                        <h2 className="jd-heading-main font-weight600  font-size-heading">
                            Submission Documents
                        </h2>
                        <div className="field-cont">
                            {associated === true ? (
                                <AddSubmissionDocuments
                                    projectID={projectID}
                                    clientwiseID={clientwiseID}
                                    getSubmissionDetails={getSubmissionDetails}
                                />
                            ) : (
                                sessionStorage.getItem("edit_project_access") === "true" && (
                                    <AddSubmissionDocuments
                                        projectID={projectID}
                                        clientwiseID={clientwiseID}
                                        getSubmissionDetails={getSubmissionDetails}
                                    />
                                )
                            )}
                        </div>
                    </div>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                {/* <div className="datagrid-container">
                    <div className="invoice-table"> */}

                <div className="invoice-table2 ">
                    <table className="project-details-table">
                        <thead>
                            <tr className="custom-table-head-trr">
                                <th className="align-left font-size-text font-weight600">
                                    S. No.
                                </th>
                                <th className="align-center font-size-text font-weight600">
                                    Work Stage
                                </th>
                                <th className="align-center font-size-text font-weight600">
                                    Document Name
                                </th>
                                <th className="align-center font-size-text font-weight600">
                                    Document File
                                </th>
                                <th className="align-right font-size-text font-weight600">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <Loader /> //buffering logic
                        ) : (
                            <tbody>
                                {submissionDocs.map((i, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="tr-border-bottom">
                                            <td colSpan="6"></td>
                                        </tr>
                                        <tr className="custom-table-head-tddd font-weight500 font-size-label">
                                            <td className="align-left">{index + 1}</td>
                                            <td className="align-center">{i.workstage_name}</td>
                                            <td className="align-center">{i.document_name}</td>
                                            <td className="align-center">
                                                {i.file ? (
                                                    // <a href={i.document_file} target="blank">
                                                    //   View
                                                    // </a>
                                                    <ViewOtherFile
                                                        filename={i.document_name}
                                                        filesrc={i.file}
                                                    />
                                                ) : (
                                                    // <a href={i.file} download={`${i.file}`} target="blank">
                                                    //     <img
                                                    //         className="performance-reward-img"
                                                    //         src={`${i.file}`}
                                                    //         alt="Submission Doc"
                                                    //     />
                                                    // </a>
                                                    "Document Not Attached"
                                                )}
                                            </td>

                                            <td className="align-right  width-5vw ">
                                                {associated === true ? (
                                                    <DeleteProjectDocuments
                                                        id={i}
                                                        getDocuments={getSubmissionDetails}
                                                    />
                                                ) : (
                                                    sessionStorage.getItem("delete_project_access") ===
                                                    "true" && (
                                                        <DeleteProjectDocuments
                                                            id={i}
                                                            getDocuments={getSubmissionDetails}
                                                        />
                                                    )
                                                )}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>

                {/* </div>
                </div> */}
                {/* </div> */}
            </div>
        </>
    );
};

const AddProjectDocuments = ({ projectID, getProjectDocuments }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const [formData, setFormData] = useState({
        project: projectID,
        document_name: "",
        file: "",
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["document_name", "file"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const formDataa = new FormData();
            formDataa.append("project", formData.project);
            formDataa.append("document_name", formData.document_name);
            formDataa.append("file", formData.file);
            try {
                let res = await axios.post(`${BASE_URL}/project/document/`, formDataa, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res.status === 200) {
                    handleClose();
                    await getProjectDocuments();
                } else {
                    alert(res);
                }
            } catch (err) {
                //    handle
            } finally {
                setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };


    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            setFormData({
                ...formData,
                [name]: file,
            });
        } else {
            setFormData({
                ...formData,
                [name]: null,
            });
        }
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    return (
        <>
            <button className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle /> Document
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="modal_width_38vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">
                        Add Tender Documents
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="justify-center">
                            <form className="">
                                <div className="flex-column">
                                    <label
                                        htmlFor="document_name"
                                        className="form-labels  font-weight500   font-size-heading"
                                    >
                                        Document Name
                                    </label>
                                    <input
                                        id="document_name"
                                        type="document_name"
                                        name="document_name"
                                        placeholder="Document Name"
                                        onChange={handleInputChange}
                                        value={formData.document_name}
                                        className={`form-input ${errors.document_name
                                            ? "error"
                                            : inputState.document_name
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.document_name && (
                                        <span className="error-message font-size-text ">
                                            {errors.document_name}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                        Attachment
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in-upload ${errors.file ? "error" : inputState.file ? "success" : ""
                                            }`}
                                    >
                                        <label style={{ cursor: "pointer" }} htmlFor="file">
                                            <CloudUpload />
                                            <span
                                                className="form-text-trasformation-uppercase"
                                                style={{ marginLeft: "20px" }}
                                            >
                                                {formData.file
                                                    ? formData.file.name
                                                    : "No file selected"}
                                            </span>
                                        </label>
                                        <input
                                            id="file"
                                            type="file"
                                            name="file"
                                            onChange={handleFileChange}
                                            style={{ display: "none", position: "relative" }}
                                        />
                                        {formData.file ? (
                                            <span
                                                className="file-clear"
                                                onClick={() => handleFileClear("file")}
                                            >
                                                Clear
                                            </span>
                                        ) : null}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal.Body>
                <div className="button-models-new " style={{ marginBottom: "10px" }}>
                    <button
                        className="model-button model-button-cancel   font-weight500   "
                        onClick={handleClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        Add
                    </button>
                </div>
            </Modal>
        </>
    );
};

const ProjectTenderDocumentTable = ({ projectID, client, associated }) => {
    const [buffer, setBuffering] = useState(false);
    const [projectDocs, setProjectDocs] = useState([]);

    useEffect(() => {
        getProjectDocuments();
    }, []);

    const getProjectDocuments = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/project/documentbyproject/${projectID}/`
            );
            setProjectDocs(res.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    return (
        <>
            <div className="table-css-white-background">
                {/* <div className="attendance-box"> */}
                <div className="heading-bg-color-white">
                    <div className="jd-heading-outer-flex ">
                        <h2 className="jd-heading-main font-weight600  font-size-heading">
                            Tender Documents
                        </h2>
                        <div className="field-cont">
                            {associated === true ? (
                                <AddProjectDocuments
                                    projectID={projectID}
                                    getProjectDocuments={getProjectDocuments}
                                />
                            ) : (
                                sessionStorage.getItem("edit_project_access") === "true" && (
                                    <AddProjectDocuments
                                        projectID={projectID}
                                        getProjectDocuments={getProjectDocuments}
                                    />
                                )
                            )}
                        </div>
                    </div>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                {/* <div className="datagrid-container">
                    <div className="invoice-table"> */}

                <div className="invoice-table2 ">
                    <table className="project-details-table">
                        <thead>
                            <tr className="custom-table-head-trr">
                                <th className="align-left font-size-text font-weight600">
                                    S. No.
                                </th>
                                <th className="align-center font-size-text font-weight600">
                                    Document Name
                                </th>
                                <th className="align-center font-size-text font-weight600">
                                    Document File
                                </th>
                                <th className="align-right font-size-text font-weight600">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <Loader /> //buffering logic
                        ) : (
                            <tbody>
                                {projectDocs.map((i, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="tr-border-bottom">
                                            <td colSpan="6"></td>
                                        </tr>
                                        <tr className="custom-table-head-tddd font-weight500 font-size-label">
                                            <td className="align-left">{index + 1}</td>
                                            <td className="align-center">{i.document_name}</td>
                                            <td className="align-center">
                                                {i.file ? (
                                                    // <a href={i.document_file} target="blank">
                                                    //   View
                                                    // </a>
                                                    <ViewOtherFile
                                                        filename={i.document_name}
                                                        filesrc={i.file}
                                                    />
                                                ) : (
                                                    // <a href={i.file} download={`${i.file}`} target="blank">
                                                    //     <img
                                                    //         className="performance-reward-img"
                                                    //         src={`${i.file}`}
                                                    //         alt="Tender Doc"
                                                    //     />
                                                    // </a>
                                                    "Document Not Attached"
                                                )}
                                            </td>

                                            <td className="align-right font-size-text font-weight400 width-5vw ">
                                                {associated === true ? (
                                                    <DeleteProjectDocuments
                                                        id={i}
                                                        getDocuments={getProjectDocuments}
                                                    />
                                                ) : (
                                                    sessionStorage.getItem("delete_project_access") ===
                                                    "true" && (
                                                        <DeleteProjectDocuments
                                                            id={i}
                                                            getDocuments={getProjectDocuments}
                                                        />
                                                    )
                                                )}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>

                {/* </div>
                </div> */}
                {/* </div> */}
            </div>
        </>
    );
};

export {
    EditInvoiceRequest,
    AddProjectClientDetails,
    DeleteProjectClientDetails,
    ProjectClientDetailsTable,
    ProjectWorkStagesTable,
    ProjectInvoicesDetailsTable,
    ProjectPerformaInvoicesDetailsTable,
    ProjectInvoicesPaymentsTable,
    ProjectSubmissionDocumentTable,
    ProjectTenderDocumentTable,
};
